<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->


<template>
    <transition name="sdev-slide">
        <div v-if="visible" class="sdev-log-wrapper">

            <!-- Overlay -->
            <div class="sdev-log-overlay" @click="closeLog"></div>

            <!-- Sidebar -->
            <aside class="sdev-log-sidebar">
                <header class="sdev-log-header">
                    <h3>{{ title }}</h3>
                    <button class="sdev-log-close" @click="closeLog">×</button>
                </header>

                <div class="sdev-log-body">
                    <div class="sdev-log-grid">
                        <div v-for="(entry, index) in logs" :key="index" class="sdev-log-row">
                            <div class="log-time">{{ entry.time }}</div>
                            <div class="log-action">{{ entry.action }}</div>
                            <div class="log-user">{{ entry.user }}</div>
                        </div>
                    </div>
                </div>
            </aside>

        </div>
    </transition>
</template>

<script setup>
import { computed } from 'vue'
import { useSidebarLog } from '@/composables/useSidebarLog'

const { visible, context, closeLog } = useSidebarLog()

const title = computed(() =>
    context.value ? `Audit Log: ${context.value}` : 'Audit Log'
)

/* v1 Mock – später API */
const logs = computed(() => [
    { time: '10:14', action: 'Created', user: 'Patrick' },
    { time: '10:18', action: 'Updated', user: 'Lea' },
    { time: '10:22', action: 'Deleted', user: 'Patrick' }
])
</script>